import { render, staticRenderFns } from "./PathwayBuilder.vue?vue&type=template&id=345f6f05&scoped=true"
import script from "./PathwayBuilder.vue?vue&type=script&lang=js"
export * from "./PathwayBuilder.vue?vue&type=script&lang=js"
import style0 from "./PathwayBuilder.vue?vue&type=style&index=0&id=345f6f05&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345f6f05",
  null
  
)

export default component.exports